'use client';

import useIsPrintModalEnabled from '@alltrails/experiments/hooks/useIsPrintModalEnabled';
import ExploreAreaPrintControl from '@/components/PrintControl/ExploreAreaPrintControl';

export default function ExploreRootPrintControlSlot() {
  return useIsPrintModalEnabled() ? <ExploreAreaPrintControl /> : null;
}
